export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
 


// WEBPACK FOOTER //
// ./src/redux/actionTypes.js